import { useEffect } from 'react';
import { useMap } from './MapContext';
import useBoundedMapElement from './useBoundedMapElement';

const useMarker = (openStreetMapsObj, isBounded = false) => {
    const {map} = useMap();

    useEffect(() => {
        if (map) {
            openStreetMapsObj.addTo(map);

            return () => {
                openStreetMapsObj.removeFrom(map);
            };
        }
        return undefined;
    }, [map, openStreetMapsObj]);

    useBoundedMapElement(openStreetMapsObj, isBounded);
    return undefined;
};

export default useMarker;



// WEBPACK FOOTER //
// ./src/components/openMap/useMarker.js